import useVenuesApi from 'firebaseKit/venues'
import React, { createContext, useContext, useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'

const VenueContext = createContext()

const VenueProvider = (props) => {
  const [searchParams, _setSearchParams] = useSearchParams()
  const [currentVenue, setCurrentVenue] = useState(props.default)
  const [currentVenueData, setCurrentVenueData] = useState(null)
  const [isDefaultVenue, setIsDefaultVenue] = useState(true)
  const location = useLocation()
  const { getVenue } = useVenuesApi()

  // Set the current venue ID:
  // - If the page is "/": set the venue to whatever is in the query
  //   string "venue" parameter, otherwise use the default.
  // - Otherwise: use localStorage "current_venue" or the default.
  useEffect(() => {
    const spVenue = searchParams.get('venue') || props.default
    if (location.pathname === '/') {
      setIsDefaultVenue(spVenue === props.default)
      setCurrentVenue(spVenue)
      localStorage.setItem('current_venue', spVenue)
    } else {
      const lsVenue = localStorage.getItem('current_venue') || props.default
      setIsDefaultVenue(lsVenue === props.default)
      setCurrentVenue(lsVenue)
      localStorage.setItem('current_venue', lsVenue)
    }
  }, [location, searchParams])

  useEffect(() => {
    let ignore = false
    const getVenueData = async () => {
      const res = await getVenue(currentVenue)
      if (ignore) {
        return
      }
      setCurrentVenueData(res)
    }
    getVenueData()
    return () => {
      ignore = true
    }
  }, [currentVenue])

  const value = {
    currentVenue,
    currentVenueData,
    defaultVenue: props.default,
    isDefaultVenue
  }
  return (
    <VenueContext.Provider value={value}>{props.children}</VenueContext.Provider>
  )
}

export default VenueProvider

export const useVenueContext = () => {
  return useContext(VenueContext)
}
